import { render, staticRenderFns } from "./DonutChart77.vue?vue&type=template&id=71660ee8&scoped=true&"
import script from "./DonutChart77.vue?vue&type=script&lang=js&"
export * from "./DonutChart77.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71660ee8",
  null
  
)

export default component.exports